import Image from "next/image";

const logos = [
	{ src: "/images/clients/1.svg", alt: "Client 1", width: 97, height: 15 },
	{ src: "/images/clients/2.svg", alt: "Client 2", width: 87, height: 19 },
	{ src: "/images/clients/3.svg", alt: "Client 3", width: 68, height: 16 },
	{ src: "/images/clients/6.svg", alt: "Client 6", width: 88, height: 26 },
	{ src: "/images/clients/7.svg", alt: "Client 7", width: 83, height: 19 },
	{ src: "/images/clients/8.svg", alt: "Client 8", width: 95, height: 15 },
];

const gapMap = {
	default: "gap-8",
	lg: "gap-10",
} as const;

export default function IntroLogos({
	title = "Industry-leaders trust us — now it\u0027s your turn.",
	gap = "default",
}: {
	title?: string;
	gap?: keyof typeof gapMap;
} = {}) {
	return (
		<div className={`flex w-full flex-col items-center ${gapMap[gap]}`}>
			<p className="font-display text-sm font-medium leading-5 text-[rgba(9,10,12,0.56)]">
				{title}
			</p>

			<div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-5 lg:flex-nowrap">
				{logos.map((logo) => (
					<div
						key={logo.src}
						className="flex items-center justify-center"
						style={{ width: logo.width, height: logo.height }}
					>
						<Image
							src={logo.src}
							alt={logo.alt}
							width={logo.width}
							height={logo.height}
							className="h-full w-full object-contain"
							loading="lazy"
						/>
					</div>
				))}
			</div>
		</div>
	);
}
